import * as React from "react";
import styles from "./error_page.module.sass";

export const UnsupportedBrowser = (): JSX.Element => (
  <div className={styles.categoryErrorPage}>
    <h1>
      Používáte prohlížeč, který není na Spořílek.cz podporován <br />
    </h1>

    <p>&nbsp;</p>

    <p>Použijte prosím Chrome, Firefox, Safari, Opera, nebo Edge.</p>

    <p>
      <a className="button btn-large button-primary" href="/">
        Přejít na hlavní stranu
      </a>
    </p>
  </div>
);
